import { AdminUser } from '../../../queries/types'

export const nameForUser = (user?: AdminUser | null) => {
  // Prefer profile names over user names
  const firstName = user?.profile?.firstName || user?.firstName
  const lastName = user?.profile?.lastName || user?.lastName

  return (firstName ? `${firstName} ${lastName}` : user?.emailAddress) ?? ''
}

export const profileForUser = (user?: AdminUser | null) => {
  // Prefer profile names over user names
  const firstName = user?.profile?.firstName || user?.firstName
  const lastName = user?.profile?.lastName || user?.lastName

  return (firstName ? `${firstName} ${lastName}` : user?.id) ?? ''
}

export const profileUrlForUser = (user?: AdminUser | null) =>
  `/admin/profiles/show/${user?.profileId}`

export const userUrlForUser = (user?: AdminUser | null) =>
  `/admin/roles/user/${user?.id}`
